// extracted by mini-css-extract-plugin
export default {"tab":"tabs_tab__wK+h9","active":"tabs_active__0y+wP","tabcontent":"tabs_tabcontent__BuaHQ"};